import config from '../../config';

import { fetchData } from '../utils/fetch';

export const fetchBingoGames = async ({
  locale,
  market_country,
  market_region,
}: {
  locale?: string;
  market_country?: string;
  market_region?: string;
}) => {
  try {
    const response = await fetchData<Record<string, any>>({
      url: `${config.urls.bffBaseUrl}/bingo-rooms`,
      queryParameters: {
        market_country,
        market_region,
        locale,
      },
    });

    return {
      status: 200,
      data: response?.games || [],
    };
  } catch (err) {
    console.error(
      `There was a problem while fetching bingo games. ${config.urls.bffBaseUrl}/bingo-rooms.`
    );
    console.error(err);

    return { status: err.status, data: [] };
  }
};
